//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.StructureDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../Features/Features.StructureDesign.ContextAttributeBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Features.js";
let d=[[[0,"Chamfer",1,0],[1,"ChamferLength",0,"Expression",0],[1,"ContextAttribute",0,"Features.StructureDesign.ContextAttributeBuilder",0],[0,"DistanceTolerance",1,0],[0,"EndCapName",1,0],[0,"EnumCornerTreatmentType",1,0],[1,"Member",0,"ScCollector",0],[1,"Offset",0,"Expression",0],[0,"OffsetRatio",1,0],[0,"PlacementType",1,0],[0,"PreserveOverallLength",1,0],[1,"Thickness",0,"Expression",0]],[],[]];
SPLM.Features.StructureDesign.EndcapBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StructureDesign.EndcapBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StructureDesign.EndcapBuilder.PlacementTypes = Object.freeze({
    "Inside" : "Inside", "Outside" : "Outside"});

SPLM.Features.StructureDesign.EndcapBuilder.CornerTreatmentTypes = Object.freeze({
    "None" : "None", "Chamfer" : "Chamfer", "Fillet" : "Fillet"});

export default SPLM;